// extracted by mini-css-extract-plugin
export default {"component":"_30l6K"};